import React from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../../../../CommonComponents/OPL/Button/Button';
import { selectPlan } from '../../../../../../../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsActions';
import { navigateToGoal } from '../../utils/navigateToGoal';
import { ButtonCell, ButtonsRow } from './Footer.styles';
import { useGoal } from '../../../../../../hooks/useGoal';

interface Props {
  planIds: string[];
  clientId: string;
  goalId: string;
}

export const Footer: React.FC<Props> = ({ planIds, clientId, goalId }) => {
  const { data: goal } = useGoal({ goalId });

  const dispatch = useDispatch();

  if (!goal) {
    return null;
  }

  return (
    <Box
      position="sticky"
      bottom={0}
      borderColor="neutral.200"
      borderTopStyle="solid"
      borderTopWidth={1}
      bg="bg"
      py="16"
    >
      <ButtonsRow>
        <ButtonCell>
          <Button
            size="large"
            variant="secondary"
            onClick={() => navigateToGoal(clientId, goalId, goal.GoalType)}
          >
            Back
          </Button>
        </ButtonCell>

        {planIds.map(planId => (
          <ButtonCell key={planId}>
            <Button
              size="large"
              onClick={() => {
                dispatch(selectPlan(planId, clientId));

                navigateToGoal(clientId, goalId, goal.GoalType);
              }}
            >
              Select This Plan
            </Button>
          </ButtonCell>
        ))}
      </ButtonsRow>
    </Box>
  );
};
